// extracted by mini-css-extract-plugin
export var tosLink = "_dv-0";